import {useIntl} from 'react-intl'
import {CreateFields, SearchForAddressFormFields} from '../../types/forms'

export const useSearchForAddressFields: CreateFields<SearchForAddressFormFields, {required?: boolean}> = ({
  form: {
    control,
    formState: {errors},
  },
  label = 'Enter address',
  required = true,
}) => {
  const {formatMessage} = useIntl()

  const fields = {
    searchForAddress: {
      name: `searchForAddress` as const,
      label: label,
      defaultValue: '',
      type: 'text' as const,
      error: errors[`searchForAddress`],
      rules: {
        validate: (value: string) => {
          if (!required) return true
          return value?.trim() ? true : formatMessage({defaultMessage: 'This field is required.'})
        }
      },
      control,
    },
  }

  return fields
}
